import type { SelectableChartType } from '../dashboard-capabilities/types/chart';
import { DataType } from './data-type';

const D = DataType;
type SupportedChartInputType = SelectableChartType | 'share-of-segment';

/**
 * Maps each selectable chart type to DataTypes it can render.
 * Order is preference priority (first = most preferred).
 */
export const CHART_INPUT_REQUIREMENTS: Record<
  SupportedChartInputType,
  DataType[]
> = {
  bar: [D.SINGLE, D.BREAKDOWN_SINGLE],
  'stacked-bar': [D.BREAKDOWN_SINGLE, D.BREAKDOWN_TIMESERIES],
  'grouped-bar': [D.BREAKDOWN_SINGLE, D.BOX],
  'diverging-bar': [D.BREAKDOWN_SINGLE],
  'diverging-bar-combo': [D.BREAKDOWN_SINGLE],
  line: [D.TIMESERIES, D.BREAKDOWN_TIMESERIES],
  'share-of-segment': [D.TIMESERIES, D.BREAKDOWN_TIMESERIES],
  volume: [D.TIMESERIES],
  treemap: [D.SINGLE, D.BREAKDOWN_SINGLE],
  icicle: [D.SINGLE, D.BREAKDOWN_SINGLE],
  sankey: [D.FLOW_BREAKDOWN_SINGLE],
  chord: [D.FLOW_BREAKDOWN_SINGLE],
  distribution: [D.DISTRIBUTION],
  box: [D.BOX],
  map: [D.MAP],
  table: [D.TABLE_ROWS, D.SINGLE, D.BREAKDOWN_SINGLE, D.TIMESERIES, D.BOX],
  text: [D.TABLE_ROWS],
  'gauge-v2': [D.SINGLE],
  'ai-summary': [D.TABLE_ROWS],
};
